import React from 'react';
import './EightSection.css';

const EightSection = () => {
  return (
    <div className="eight-section-container">
      <div className="eight-box">
        {/* ✅ Use image from public/assets */}
        <div className="eight-icon-wrapper">
          <img src="/assets/Multidisciplinary-design.png" alt="Helmet Icon" className="cad-icon-img" />
        </div>

        <h2>HEXAGON PPM SMART 3D /AVEVA EVERYTHING3D Multidisciplinary Design</h2>

        

        <div className="cad-list-section">
          
          <ul>
            <li>Plant design layout</li>
            <li>Basic designs </li>
            <li>Reverse engineering</li>
            <li>Piping Equipment and support detail design</li>
            <li>Simulation of maintenance</li>
            <li>Verification, optimization</li>
            <li>Validation of project feasibility</li>
            <li>Isometric extraction</li>
            <li>2D Piping,Equipment Layout extraction</li>
            <li>B.O.M.</li>
            <li>All type of reports</li>
          </ul>
        </div>

        

        
      </div>
    </div>
  );
};

export default EightSection;